import { setCurrentLocation } from '@/core/redux/currentLocationSlice';
import { RootState } from '@/core/redux/store';
import { getData } from '@/services/api.service';
import { routePrefix } from '@/utils/routes/routes';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

interface PostCodeData {
  postcode: string;
  id?: string;
  [key: string]: any;
}

const BannerSection = ({ themeData }: any) => {
  const [pinCode, setPinCode] = useState<string>('');
  const [postCodeList, setPostCodeList] = useState<any[]>([]);
  const [selectedPostCode, setSelectedPostCode] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const headerData = useSelector((state: RootState) => state.common.header);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handlePostcodeSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!pinCode.trim()) {
      setError('Postcode is required');
      return;
    }

    setIsLoading(true);
    try {
      const response = await getData(`get_shop_by_pincode?pincode=${pinCode}`);

      if (response.status === 200 || response.status === 201) {
        if (response?.data?.success && response?.data?.data?.id) {
          navigate(`${routePrefix}/shop/${response.data.data.id}`);
          dispatch(setCurrentLocation(response.data.data));
        } else {
          setError('No shop found for this postcode');
        }
      }
    } catch (err: any) {
      setError('Area not covered');
    } finally {
      setIsLoading(false);
    }
  };

  const getPostalCode = async () => {
    try {
      const response = await getData(`get_postal_codes?keyword=${pinCode}`);

      if (response.status === 200 || response.status === 201) {
        setPostCodeList(response?.data?.data || []);
      }
    } catch (err) {
      console.error('Failed to fetch postal codes:', err);
      setPostCodeList([]);
    }
  };

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (pinCode && !selectedPostCode) getPostalCode();
    }, 100);

    return () => clearTimeout(debounceTimer);
  }, [pinCode]);

  useEffect(() => {
    if (selectedPostCode) {
      setPinCode(selectedPostCode);
      setPostCodeList([]);
    }
  }, [selectedPostCode]);
  return (
    <>
      <div
        style={{
          background: `url(${themeData?.theme_1?.home?.section_1?.banner})`,
        }}
      >
        {themeData?.theme_1?.home?.section_1?.banner_type == 'video' && (
          <video
            loop
            autoPlay
            src={themeData?.theme_1?.home?.section_1?.banner}
          ></video>
        )}
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-lg-7">
              <div className="banner-search-wrap">
                <span className="banner-tag">
                  {themeData?.theme_1?.home?.section_1?.sub_heading_top}
                  {/* {themeData?.theme_1?.home?.section_1?.banner_type} */}
                </span>
                <h1
                  style={{
                    color:
                      `#${themeData?.theme_1?.home?.section_1?.title_color}` ||
                      '#000000',
                  }}
                >
                  {themeData?.theme_1?.home?.section_1?.title}
                </h1>
                <p
                  id="bookNow"
                  className="d-none d-md-block mb-5"
                  style={{
                    color:
                      `#${themeData?.theme_1?.home?.section_1?.paragraph_color}` ||
                      '#000000',
                  }}
                >
                  {themeData?.theme_1?.home?.section_1?.paragraph}
                </p>
                {headerData?.postal_code_enabled == '1' && (
                  <div className="postcodeform-container">
                    <form onSubmit={handlePostcodeSubmit}>
                      <div>
                        {error && (
                          <small className="text-danger postvalidation">
                            {error}
                          </small>
                        )}
                        <div className="postcodeform">
                          <input
                            name="pinCode"
                            type="text"
                            id="postcode-input"
                            placeholder={
                              themeData?.theme_1?.home?.section_1?.btn_group
                                ?.btn1?.placeholder
                            }
                            className="ui-autocomplete-input"
                            autoComplete="off"
                            value={pinCode}
                            onChange={(e) => {
                              setPinCode(e.target.value);
                              setError('');
                            }}
                          />
                          <button
                            className="btn hover-btn"
                            id="book_now_btn"
                            type="submit"
                            style={{
                              background: `#${themeData?.theme_1?.home?.section_1?.btn_group
                                ?.btn1?.bg_color}`,
                              color: `#${themeData?.theme_1?.home?.section_1?.btn_group
                                ?.btn1?.color}`,
                            }}
                            disabled={isLoading}
                          >
                            {
                              themeData?.theme_1?.home?.section_1?.btn_group
                                ?.btn1?.text
                            }
                          </button>
                          {postCodeList.length > 0 && (
                            <div className="dropdown">
                              {postCodeList.map((data: PostCodeData) => (
                                <div
                                  key={data.postcode}
                                  className="dropdown-row"
                                  onClick={() =>
                                    setSelectedPostCode(data.postcode)
                                  }
                                >
                                  <i className="fas fa-map-marker-alt"></i>
                                  {data.postcode}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </form>
                  </div>
                )}
              </div>
              {/* <SectionOfferSingle /> */}
            </div>
            <div className="col-md-12 col-lg-5"></div>
          </div>
        </div>
      </div>
      {/* {settingsData?.WebsiteSettings?.site_title_en.includes(
        'Peter Borough'
      ) && (
        <>
          <div className="homesearch">
            <div className="container">
              <div className="row">
                <div className="col-md-4">
                  <p>Select your time & location for the service</p>
                </div>
                <div className="col-md-8">
                  <div className="postcodeform-container">
                    <form onSubmit={handlePinCodeSubmit(submitPostalForm)}>
                      <div
                        className={`${
                          checkWithNewPin == false ? 'd-none' : ''
                        }`}
                      >
                        <small className="text-danger postvalidation">
                          {pinCodeFormError.pinCode?.message}
                        </small>
                        <div className="postcodeform">
                          <Controller
                            name="pinCode"
                            control={pinCodeFormControl}
                            render={({ field }) => (
                              <input
                                type="text"
                                id="postcode-input"
                                {...field}
                                placeholder="Enter Postcode"
                                className={`ui-autocomplete-input ${
                                  pinCodeFormError.pinCode ? 'invalid' : ''
                                }`}
                              />
                            )}
                          />
                          <button
                            className="btn hover-btn"
                            id="book_now_btn"
                            type="submit"
                          >
                            <img src={vehicle} alt="" className="me-2" />
                            Book Now
                          </button>
                        </div>
                      </div>
                    </form>
                    <form>
                      <div
                        className={`adrsselectform ${
                          checkWithNewPin == true ? 'd-none' : ''
                        }`}
                      >
                        <small className="text-danger postvalidation">
                          {addressFormError.address?.message}
                        </small>
                        <div className="adrsselectdd">
                          <Controller
                            name="address"
                            control={addressFormControl}
                            render={({ field }) => (
                              <Select
                                placeholder="Select your address"
                                {...field}
                                value={selectedAddress}
                                className={`${
                                  addressFormError.address ? 'invalid' : ''
                                }`}
                                onChange={handleAddressChange}
                                onFocus={() => {
                                  if (
                                    getValuesAddressForm('address').value == ''
                                  ) {
                                    addressFormSetError('address', {
                                      type: 'server',
                                      message: 'Address is required to proceed',
                                    });
                                  } else {
                                    clearErrors();
                                  }
                                }}
                                options={areaOptions}
                              />
                            )}
                          />

                          <input
                            type="button"
                            value="Continue"
                            className="btn hover-btn"
                            onClick={submitAddressChange}
                          />
                        </div>
                        <div className="adrsselect-or">OR</div>
                        <div className="adrsselect-link">
                          <a
                            className="cursor-pointer"
                            onClick={() => {
                              setCheckWithNewPin(true);
                            }}
                          >
                            Check with another Postcode
                          </a>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )} */}
    </>
  );
};

export default BannerSection;
